//----------------------
// sort multiple fields
//----------------------
export default function sortMultiFields(prop) {
  return function (a, b) {
    for (let i = 0; i < prop.length; i++) {
      var reg = /^\d+$/;
      var x = 1;
      var field1 = prop[i];
      if (prop[i].indexOf("-") == 0) {
        field1 = prop[i].substr(1, prop[i].length);
        x = -x;
      }

      if (reg.test(a[field1])) {
        a[field1] = parseFloat(a[field1]);
        b[field1] = parseFloat(b[field1]);
      }
      if (a[field1] > b[field1]) return x;
      else if (a[field1] < b[field1]) return -x;
    }
  };
}
